import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Table from '../../../../components/Table';
import CollegeCornerFilters from '../../filters/CollegeCornerFilters';

import { queryCollegePlayersAPI } from '../../../../actions/college-corner.actions';
import { parseQueryParams, setQueryParams } from '../../../../utils/collegeCorner';
import { initialState } from '../helpers';
import { columns, initialFilters } from './helpers';

import styles from './CollegeCornerCollegePlayers.scss';

function CollegeCornerCollegePlayers({ history, location, isPowerUser, hideMaskedP6, handleUpgradeToPowerClick, upgradeButtonLabel }) {
    const dispatch = useDispatch();
    const [data, setData] = useState(initialState);
    const [filters, setFilters] = useState();
    const [tempFilters, setTempFilters] = useState({});

    const callCollegePlayersAPI = ({ ...params }) => dispatch(queryCollegePlayersAPI({ ...params }));

    useEffect(() => {
        setFilters({ ...initialFilters, ...parseQueryParams(location.search) });
    }, []);

    useEffect(() => {
        if (filters) {
            const query = setQueryParams(filters);
            history.replace(`${location.pathname}?${query}`);
        }
    }, [filters]);

    const onAPILoad = async (apiData, reset = false) => {
        if (reset) { setData(initialState); }
        const response = await callCollegePlayersAPI(apiData);
        const { rows, count } = response;
        if (rows) {
            setData(() => ({
                rows,
                count,
                isLoad: false,
            }));
        }
    };

    const onhandleSort = (sortValue) => {
        if (sortValue && sortValue === filters?.sort) {
            setFilters((prevState) => ({
                ...prevState,
                order: filters?.order === 'asc' ? 'desc' : 'asc',
                page: 1,
            }));
        } else {
            setFilters((prevState) => ({
                ...prevState,
                sort: sortValue,
                order: 'desc',
                page: 1,
            }));
        }
    };

    const onLoadMore = () => {
        setFilters((prevState) => ({
            ...prevState,
            page: prevState?.page + 1,
        }));
    };

    const isPropsValid = (props) => {
        return props
            ? Object.keys(props).filter((v) => Object.keys(filters).indexOf(v) > -1)
                .length > 0
            : {};
    };

    const onhandleUpdateFilters = (updatedFilters) => {
        const updatedProps = isPropsValid(updatedFilters) ? updatedFilters : {};
        setTempFilters((prevState) => ({
            ...prevState,
            ...updatedProps,
        }));
    };

    const onhandleFilterSubmit = (props) => {
        const updatedProps = isPropsValid(props) ? props : {};
        setFilters((prevState) => ({
            ...prevState,
            ...tempFilters,
            ...updatedProps,
            page: 1,
        }));
        setTempFilters({});
    };

    const onhandleResetFilters = () => {
        setTempFilters({});
        setFilters(initialFilters);
    };

    const hidePlayerP6Ratings = hideMaskedP6 ? ['doublesUtrMasked', 'singlesUtrMasked'] : ['singlesUtr', 'doublesUtr'];

    const isVisibleUpgradedText =
        !isPowerUser && data.rows?.length === data.count;
    const customText =
        'There are no results that meet this criteria.';
    return (
        <div className={`${styles.CollegePlayers}`}>
            <CollegeCornerFilters
                tempFilters={tempFilters}
                defaultFilters={filters}
                onhandleUpdateFilters={onhandleUpdateFilters}
                onhandleFilterSubmit={onhandleFilterSubmit}
                onhandleResetFilters={onhandleResetFilters}
                filterOptions={['gender', 'utr', 'division', 'conference']}
                sortingOptions={columns
                    .filter((v) => v.sortable !== false)
                    .map((v) => ({ label: v.title, value: v.key }))}
            />
            <div className={`${styles.dividerWhite}`} />
            <Table
                sortRuleChanger={onhandleSort}
                columns={columns.map(({ title, custom, key, maxWidth, rowClassName }) => ({
                    title,
                    custom,
                    key,
                    maxWidth,
                    rowClassName,
                    hideColumn: hidePlayerP6Ratings.includes(key),
                }))}
                data={data}
                filters={filters}
                asyncCall={onAPILoad}
                onhandleClickLoadMore={onLoadMore}
                mergeData
                customNoRowsText={customText}
            />

            {!data.isLoad && isVisibleUpgradedText && (
                <p className={`${styles.moreResults}`}>
                    Want to see more results?{' '}
                    <a
                        href="#"
                        onClick={handleUpgradeToPowerClick}
                        className="clickable text-teal"
                    >
                        {upgradeButtonLabel}
                    </a>
                </p>
            )}
        </div>
    );
}

CollegeCornerCollegePlayers.propTypes = {
    history: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
    isPowerUser: PropTypes.bool,
    hideMaskedP6: PropTypes.bool,
    handleUpgradeToPowerClick: PropTypes.func,
    upgradeButtonLabel: PropTypes.string,
};

CollegeCornerCollegePlayers.defaultProps = {
    isPowerUser: false,
    hideMaskedP6: false,
    handleUpgradeToPowerClick: () => { },
    upgradeButtonLabel: 'Upgrade to Power',
};

export default CollegeCornerCollegePlayers;
